import React, { useState, useEffect } from "react";
import "./competence.css";

const Competence = () => {
  const competences = [
    { src: "https://img.icons8.com/color/48/000000/html-5--v1.png", alt: "html", label: "HTML5" },
    { src: "https://img.icons8.com/color/48/000000/css3.png", alt: "css", label: "CSS3" },
    { src: "https://img.icons8.com/color/48/000000/sass.png", alt: "sass", label: "Sass" },

    { src: "https://img.icons8.com/color/48/000000/javascript--v1.png", alt: "javascript", label: "JavaScript" },
    { src: "https://img.icons8.com/color/48/000000/react-native.png", alt: "react", label: "React" },
    { src: "https://img.icons8.com/color/48/000000/nodejs.png", alt: "node", label: "Node.js" },
    { src: "https://img.icons8.com/color/48/000000/mongodb.png", alt: "mongo", label: "MongoDB" },
    { src: "https://img.icons8.com/color/48/000000/git.png", alt: "git", label: "Git" },
    { src: "https://img.icons8.com/color/48/000000/bitbucket.png", alt: "bitbucket", label: "Bitbucket" },
    { src: "https://img.icons8.com/color/48/000000/github--v1.png", alt: "github", label: "GitHub" },
    { src: "https://img.icons8.com/color/48/000000/npm.png", alt: "npm", label: "NPM" },
    { src: "https://img.icons8.com/color/48/000000/visual-studio-code-2019.png", alt: "vscode", label: "VS Code" },
    { src: "https://img.icons8.com/color/48/000000/google-web-search.png", alt: "seo", label: "SEO" },
    { src: "https://img.icons8.com/color/48/000000/settings.png", alt: "maintenance", label: "Maintenance" },
    { src: "https://img.icons8.com/color/48/000000/cloud.png", alt: "cloud", label: "Cloud Computing" },
    { src: "https://img.icons8.com/color/48/000000/docker.png", alt: "docker", label: "Docker" },
    { src: "https://img.icons8.com/color/48/000000/api.png", alt: "api", label: "API Development" },
    { src: "https://img.icons8.com/color/48/000000/firebase.png", alt: "firebase", label: "Firebase" },
    { src: "https://img.icons8.com/color/48/000000/amazon-web-services.png", alt: "aws", label: "AWS" },
    { src: "https://img.icons8.com/color/48/000000/graphql.png", alt: "graphql", label: "GraphQL" },
    { src: "https://img.icons8.com/?size=48&id=34301&format=png", alt: "unreal-engine", label: "Unreal Engine 5" },
{ src: "https://img.icons8.com/?size=48&id=23885&format=png", alt: "blueprints", label: "Blueprints (UE5)" },
{ src: "https://img.icons8.com/?size=48&id=40669&format=png", alt: "cpp", label: "C++" },
{ src: "https://img.icons8.com/?size=48&id=25018&format=png", alt: "3d", label: "3D" },
   
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(4);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + itemsToShow) % competences.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - itemsToShow + competences.length) % competences.length);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setItemsToShow(3);
      } else {
        setItemsToShow(4);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial value

    const interval = setInterval(() => {
      nextSlide();
    }, 3000); // Change slide every 3 seconds

    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(interval);
    };
  }, [itemsToShow]);

  const visibleCompetences = competences.slice(currentIndex, currentIndex + itemsToShow);

  return (
    <div className="competences-container">
      <button className="arrow left-arrow" onClick={prevSlide}>
        &#10094;
      </button>
      <div className="competences-list">
        {visibleCompetences.map((competence, index) => (
          <div className="competence" key={index}>
            <img src={competence.src} alt={competence.alt} />
            <p>{competence.label}</p>
          </div>
        ))}
      </div>
      <button className="arrow right-arrow" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default Competence;
